export default __webpack_public_path__ + "static/media/woman-media.d5d87ceb.png";